$(document).ready(function(){
  
  $(document).on('keypress','#nt_search_canvas .search_header__input',function(){ 
      var search_val = $(this).val();
  });

  $(document).on('click','.main_menu_url .nav_link_txt',function(e){
    e.preventDefault(e);
    var link = $(this).parents('.main_menu_url').attr('href');
    window.location.href = link;
  });
  $('.collection_description_read_more').click(function(){
    $('.collection_description_info').addClass('active');
    $(this).hide();
    $('.collection_description_read_less').show();
  });
  $('.collection_description_read_less').click(function(){
    $('.collection_description_info').removeClass('active');
    $(this).hide();
    $('.collection_description_read_more').show();
  });
  
  $('.baby_mom_description_read_more').click(function(){
    $('.baby_mom_description_wrapper_info').addClass('active');
    $(this).hide();
    $('.baby_mom_description_read_less').show();
  });
  $('.baby_mom_description_read_less').click(function(){
    $('.baby_mom_description_wrapper_info').removeClass('active');
    $(this).hide();
    $('.baby_mom_description_read_more').show();
  });
});